import ModalBody from '../../shared/components/ModalBody';
import { Button, notification } from 'antd';
import Modal from '../../shared/components/Modal';
import React, { useState } from 'react';
import { getStripeUrl } from '../../redux/actions/eCommerceActions';

export const LimitUpgradeModal = ({
  show,
  onHide,
  limitType = 'general',
  currentUsage,
  maxLimit,
}) => {
  const [fetchingUpgradeLink, setFetchingUpgradeLink] = useState(false);

  const limitConfig = {
    users: {
      title: 'User Limit Reached',
      icon: '👥',
      message: `You're using ${currentUsage}/${maxLimit} available users on your plan.`,
    },
    monitors: {
      title: 'Monitor Limit Reached',
      icon: '🔍',
      message: `You've reached your plan's limit of ${maxLimit} monitors.`,
    },
    general: {
      title: 'Plan Limit Reached',
      icon: '🚀',
      message: `You've reached a limit on your current plan.`,
    },
  };

  const config = limitConfig[limitType] || limitConfig.general;

  const handleUpgradeClick = () => {
    setFetchingUpgradeLink(true);
    getStripeUrl()
      .then((request) => {
        window.location.href = request.url;
      })
      .catch((e) => {
        notification.error({
          key: 'upgrade-error',
          message: 'Error occurred',
          description: e.message,
        });
      })
      .finally(() => {
        setFetchingUpgradeLink(false);
        if (onHide) onHide();
      });
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      title={config.title}>
      <ModalBody>
        <div style={{ textAlign: 'center', padding: '10px' }}>
          <div style={{ fontSize: '70px', marginBottom: '20px', color: '#06abc1' }}>
            {config.icon}
          </div>
          <h2 style={{ fontWeight: 'bold', marginBottom: '15px' }}>{config.message}</h2>
          <div style={{ fontSize: '16px', marginBottom: '20px' }}>
            Upgrade to our next tier to expand your capabilities.
          </div>

          <Button
            type="primary"
            size="large"
            style={{
              background: '#06abc1',
              borderColor: '#06abc1',
              width: '80%',
              height: '48px',
              fontSize: '16px',
              fontWeight: 'bold',
            }}
            loading={fetchingUpgradeLink}
            onClick={handleUpgradeClick}>
            Upgrade Now
          </Button>
          <div style={{ marginTop: '15px' }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (onHide) onHide();
              }}>
              Stay on Current Plan
            </a>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
